module.exports = __webpack_public_path__ + "img/图像 95.acfeb5e1.png";